import { useAbility } from 'permissions/hooks/useAbility';
import { Actions, Subjects } from 'src/permissions/ability';

export const useAdminAvailable = () => {
  const ability = useAbility();

  return (
    ability.can(Actions.edit, Subjects.customFields) ||
    ability.can(Actions.edit, Subjects.importRsims)
  );
};
